<template>
  <ValidationObserver
    ref="validationObserver"
    v-slot="{ validated, invalid }"
  >
    <div class="p-8 pt-0">
      <div
        v-if="errorMessage || (validated && invalid)"
        class="flex mt-8"
      >
        <div class="w-full">
          <alert type="error">
            {{ errorMessage || $t('forms.validationError') }}
          </alert>
        </div>
      </div>

      <section class="flex flex-col mt-10">
        <div class="flex flex-wrap">
          <template v-if="isNew">
            <div class="w-1/2 px-2 mb-6">
              <input-select-validated
                ref="landingpageTemplate.type"
                v-model="landingpageTemplate.type"
                :options="selectableTypes"
                :label="$t('pages.landingpages.form.type')"
                rules="required"
              />
            </div>

            <div class="w-1/2 px-2 mb-6">
              <input-select-validated
                ref="landingpageTemplate.countryCodes"
                v-model="landingpageTemplate.countryCodes"
                :options="selectableCountryCodes"
                :label="$t('pages.landingpages.form.countries')"
                rules="required"
              />
            </div>

            <div class="w-1/2 px-2 mb-6">
              <input-text-validated
                ref="landingpageTemplate.slug"
                v-model="landingpageTemplate.slug"
                input-class="w-full"
                :label="$t('pages.landingpages.form.slug')"
                rules="required|slug"
              />
            </div>

            <div class="w-1/2 px-2 mb-6">
              <input-text-validated
                ref="landingpageTemplate.name"
                v-model="landingpageTemplate.name"
                input-class="w-full"
                :label="$t('pages.landingpages.form.name')"
                rules="required"
              />
            </div>
          </template>
        </div>

        <div class="flex justify-center">
          <div class="pt-8">
            <button
              :disabled="isSubmitting"
              class="btn-primary"
              @click="submit()"
            >
              <span v-if="isSubmitting">{{ $t('pages.landingpages.form.saving') }}</span>
              <span v-else>{{ $t('pages.landingpages.form.save') }}</span>
            </button>
          </div>
        </div>
      </section>
    </div>
  </ValidationObserver>
</template>

<script>
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import InputSelectValidated from '@/components/form/select-validated'
import InputTextValidated from '@/components/form/text-validated'
import Alert from '@/components/alert'

export default {
  components: {
    InputSelectValidated,
    InputTextValidated,
    Alert
  },

  props: {
    landingpageTemplate: {
      type: Object,
      required: true
    },
    onSubmit: {
      type: Function,
      required: true
    },
    errorMessage: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      faPlus,
      faTrash,
      isSubmitting: false
    }
  },

  computed: {
    isNew () {
      return !this.landingpageTemplate.id
    },

    selectableTypes () {
      return [
        { name: this.$t('pages.landingpages.form.types.GUIDE'), value: 'GUIDE' },
        { name: this.$t('pages.landingpages.form.types.CHECKLIST'), value: 'CHECKLIST' },
        { name: this.$t('pages.landingpages.form.types.QUIZZARD'), value: 'QUIZZARD' },
        { name: this.$t('pages.landingpages.form.types.NEWSLETTER'), value: 'NEWSLETTER' }
      ]
    },

    selectableCountryCodes () {
      return [
        { name: this.$t('pages.landingpages.form.countryCodes.all'), value: 'all' },
        { name: this.$t('pages.landingpages.form.countryCodes.de'), value: 'de' },
        { name: this.$t('pages.landingpages.form.countryCodes.at'), value: 'at' },
        { name: this.$t('pages.landingpages.form.countryCodes.ch'), value: 'ch' },
        { name: this.$t('pages.landingpages.form.countryCodes.fr'), value: 'fr' },
        { name: this.$t('pages.landingpages.form.countryCodes.it'), value: 'it' },
        { name: this.$t('pages.landingpages.form.countryCodes.tr'), value: 'tr' }
      ]
    }
  },

  methods: {
    async submit () {
      this.isSubmitting = true

      const isValid = await this.$refs.validationObserver.validate()
      if (!isValid) {
        return
      }

      try {
        await this.onSubmit()
      } catch (error) {
        this.setValidationErrors(error, 'landingpageTemplate')
      }
      this.isSubmitting = false
    }
  }
}
</script>
